import { createAPIService } from './api.service';

export const MAIN_ENDPOINT = '/user/api/v2/admin/user-groups';

const service = createAPIService(MAIN_ENDPOINT);

service.getUserGroups = async params =>
  (await service.get('', { params: params })).data;

service.getUserGroup = async id => (await service.get(`/${id}`)).data;

service.createUserGroup = async group =>
  (
    await service.post('', {
      ...group,
      auth: {
        type: 'KEYCLOAK',
      },
    })
  ).data;

service.updateUserGroup = async (id, group) =>
  (await service.patch(`/${id}`, group)).data;

service.deleteUserGroup = async id => (await service.delete(`/${id}`)).data;

service.addUserGroupRole = async (id, role) =>
  (await service.post(`/${id}/roles`, role)).data;

service.deleteUserGroupRole = async (id, roleName) =>
  (await service.delete(`/${id}/roles/${roleName}`)).data;

// User groups users management
service.getUserGroupUsers = async (id, params) =>
  (await service.get(`/${id}/users`, { params: params })).data;

service.addUserGroupUsers = async (id, users) =>
  (await service.post(`/${id}/users`, users)).data;

service.deleteUserGroupUsers = async (id, users) =>
  (await service.delete(`/${id}/users/ids=${users.join()}`)).data;

// User groups users management
service.getUserGroupRoles = async (id, params) =>
  (await service.get(`/${id}/roles`, { params: params })).data;

service.addUserGroupRoles = async (id, roles) =>
  (await service.post(`/${id}/roles`, roles)).data;

service.deleteUserGroupRoles = async (id, roles) =>
  (await service.delete(`/${id}/roles?ids=${roles.join()}`)).data;

// User groups policies management
service.getUserGroupPolicies = async (id, params) =>
  (await service.get(`/${id}/policies`, { params: params })).data;

service.addUserGroupPolicies = async (id, users) =>
  (await service.post(`/${id}/policies`, users)).data;

service.deleteUserGroupPolicies = async (id, users) =>
  (await service.delete(`/${id}/policies/ids=${users.join()}`)).data;

// User groups ACTs management
service.getUserGroupActs = async (id, params) =>
  (await service.get(`/${id}/acts`, { params: params })).data;

service.addUserGroupActs = async (id, acts) =>
  (await service.post(`/${id}/acts`, acts)).data;

service.deleteUserGroupActs = async (id, acts) =>
  (await service.delete(`/${id}/acts?ids=${acts.join()}`)).data;

export default service;
